import { useEventCallback } from '../useEventCallback';
var defaultCheckKeys = ['Enter', ' '];
/**
 * bind event with a11y keyboard, `space`, `enter`, only trigger when key includes in `checkKeys`
 *
 * that will auto preventDefault by default, if you don't want that, set `false` with `preventDefault`
 */
export var useA11yKeyEvent = function (fn, _a) {
    var _b = _a === void 0 ? {} : _a, onlyOnFocus = _b.onlyOnFocus, _c = _b.preventDefault, preventDefault = _c === void 0 ? true : _c, _d = _b.checkKeys, checkKeys = _d === void 0 ? defaultCheckKeys : _d;
    return useEventCallback(function (event) {
        if (!fn || (onlyOnFocus && event.target !== event.currentTarget))
            return;
        if (checkKeys.includes(event.key)) {
            if (preventDefault)
                event.preventDefault();
            fn(event);
        }
    });
};
